export const LightTheme = {
    colors:{
        primary: 'white',
        secondary: '#fdd54f',
        orange_bar: '#E97C57',
    },
    body: {
        background: '#e2dada',
        color: '#333',
    },
    UI:{
        navigation__button: {
            hover: "rgba(163,163,163,0.53)",
        },
        grid_card: {
            background: 'linear-gradient(0deg, #eeee 0%, rgba(213, 204, 204, 0.93) 100%)',
            border: '1px solid rgba(213, 204, 204, 0.80)',
        },
    },
    about: {
        boxShadow: '0px 0px 20px 5px rgba(80, 108, 80, 0.7)',
    }
}
